import React from 'react';

export const PhoneIcon = (props) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
       stroke="#a78bfa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M22 16.92V19a2 2 0 0 1-2.18 2A19.86 19.86 0 0 1 3 5.18 2 2 0 0 1 5 3h2.09a1 1 0 0 1 .91.6l1.65 3.76a1 1 0 0 1-.27 1.11l-1.2 1.2a16 16 0 0 0 6.8 6.8l1.2-1.2a1 1 0 0 1 1.11-.27l3.76 1.65a1 1 0 0 1 .6.91z" />
  </svg>
);
